import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";

const Filter = ({ data, setFilteredData }) => {
  const [filterValues, setFilterValues] = useState({
    manufacturer: "",
    model: "",
    type: "",
    // soh: "",
    capacity: "",
    // nominal_voltage: "",
    // price: "",
  });

  const uniqueOptions = (key) => {
    if (!data) return [];
    return [...new Set(data.map(item => item[key]))];
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({ ...filterValues, [name]: value });
  };

  const filterData = () => {
    if (!data) return;
    const filteredData = data.filter((item) => {
      for (const key in filterValues) {
        if (filterValues[key] && !item[key].toLowerCase().includes(filterValues[key].toLowerCase())) {
          return false;
        }
      }
      return true;
    });
    setFilteredData(filteredData);
  };

  return (
    <div className="flex flex-col md:flex-row gap-2 items-center m-2">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-1 items-center justify-center">
        {Object.entries(filterValues).map(([key, value]) => (
          <div className="m-1 md:m-2" key={key}>
            <select
              name={key}
              value={value}
              onChange={handleFilterChange}
              className="block w-full px-1 md:px-4 py-2 text-sm md:text-base border border-gray-300 rounded-md focus:outline-none focus:border-indigo-500"
            >
              <option value="">
                {`${key.charAt(0).toUpperCase() + key.slice(1)}`}
              </option>
              {uniqueOptions(key).map(option => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
      <div className="m-2">
        <Button
          variant="contained"
          className="text-xs md:text-base"
          sx={{
            backgroundColor: "#e8442d",
            fontFamily: "Bai Jamjuree",
            "&:hover": {
              backgroundColor: "#e85d01",
            },
            "&:active": {
              backgroundColor: "#e85d01",
            },
          }}
          onClick={filterData}
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );
};

export default Filter;
